import React from "react";
import GroupCard from "./GroupCard";
import { Droppable } from "react-beautiful-dnd";

const GroupColumn = (props) => {

    const { column } = props;

    return (

        <div className="col-12 col-md-6 p-0 row-eq-height">
            <div className="bg-gray rounded-lg p-0 m-1 w-100 d-flex flex-column">
                <span className="nav justify-content-center border-bottom p-2 font-weight-bolder rounded-top bg-bluegray">{column.title}</span>
                <Droppable droppableId={column.id}>
                    {(provided, snapshot) => {
                        const bgClass = snapshot.isDraggingOver ? "bg-gray" : "bg-light"
                        return (
                            <div className={"col p-1 border rounded-bottom " + bgClass}
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                            >
                                {column.cards.map((card, i) => <GroupCard key={card.id} card={card} index={i} />)}
                                {provided.placeholder}
                            </div>
                        )
                    }}
                </Droppable>
            </div>
        </div >
    )
}

export default GroupColumn;